module.exports = __webpack_public_path__ + "assets/img/url.6c43a1cc.svg";